export enum EnumTypeSettlementGroup {
  FlexibilidadesGrupales = 1,
  FacturacionAgregada = 2,
  FacturacionResumen = 3,
  BateriaVirtual = 4,
  GrupoEmpresarial = 5
}
